import React from 'react'
import PropTypes from 'prop-types'
import { Field, formValueSelector } from 'redux-form'
import { connect } from 'react-redux'
import { cond, complement, always, nAry, either, test } from 'ramda'
import withFieldError from 'components/form/with-error'
import { SelectPickerField } from 'components/form/selectpicker'
import TweetField from 'pages/widgets/form/tweet-input/'
import PromotedOnlyCheckboxField from 'pages/widgets/form/promoted-only-checkbox/'

const selector = formValueSelector('widget')

export const TweetUrlInput = ({
  input,
  type,
  label,
  meta: { touched, error }
}) => (
  <div>
    <input
      className={'form-control ' + (error && touched ? 'has-error' : '')}
      {...input}
      type={type}
      placeholder={label}
    />
  </div>
)

TweetUrlInput.propTypes = {
  input: PropTypes.any,
  meta: PropTypes.any,
  type: PropTypes.string,
  label: PropTypes.string
}

const TweetUrlInputWithError = withFieldError(TweetUrlInput)

export const validateUrl = cond([
  [
    complement(either(nAry(1, window.twttr.txt.isValidUrl), test(/^\d{5,}$/))),
    always('Please enter a valid URL or Tweet ID')
  ]
])

export const TweetUrlField = ({ name }) => (
  <Field
    component={TweetUrlInputWithError}
    type='text'
    label={'e.g. https://twitter.com/statuses/1234567890'}
    name={name}
    validate={validateUrl}
  />
)

TweetUrlField.propTypes = {
  name: PropTypes.string
}

export const TweetTypeField = ({ name, selectedAction }) => (
  <div className='row select-group'>
    <div className='col-sm-4 br-no-pad-right component-select-picker'>
      <Field
        name={`${name}.action`}
        component={SelectPickerField}
        defaultValue='NEW_TWEET'
      >
        <option value='NEW_TWEET'>Create Tweet</option>
        <option value='EXISTING_TWEET'>Existing Tweet</option>
      </Field>
    </div>
    <div className='col-sm-8 br-no-pad-left'>
      {selectedAction === 'EXISTING_TWEET' ? (
        <TweetUrlField name={`${name}.value`} />
      ) : (
        <div className='br-has-checkbox col-sm-12'>
          <TweetField
            messageName={`${name}.value`}
            urlName={`${name}.attachmentUrl`}
            cardUriName={`${name}.cardUri`}
          />
          <PromotedOnlyCheckboxField name={name} disabled={false} />
        </div>
      )}
    </div>
  </div>
)

TweetTypeField.propTypes = {
  name: PropTypes.string,
  selectedAction: PropTypes.string
}

const TweetWithType = connect((state, props) => ({
  selectedAction: selector(state, `${props.name}.action`)
}))(TweetTypeField)

export default TweetWithType



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-triggers-actions/triggers/twitter/tweet-type-field/index.js